import { useTranslation } from '../../hooks/useTranslation';

interface NotificationToggleProps {
  value: boolean;
  onChange: (value: boolean) => void;
  defaultValue?: boolean;
}

export const NotificationToggle = ({ 
  value, 
  onChange,
  defaultValue = true
}: NotificationToggleProps) => {
  const { t } = useTranslation();
  const effectiveValue = value ?? defaultValue;

  return (
    <div className="bg-white shadow rounded-lg p-6 mb-4">
      <h3 className="text-lg font-medium text-gray-900 mb-4">{t('create_trade.notification.title')}</h3>
      <div className="flex items-center justify-between">
        <span className="text-sm text-gray-700">
          {t('create_trade.notification.description')}
        </span>
        <button
          type="button"
          role="switch"
          aria-checked={effectiveValue}
          onClick={() => onChange(!effectiveValue)}
          className={`
            relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent 
            transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
            ${effectiveValue ? 'bg-blue-600' : 'bg-gray-200'}
          `}
        >
          <span
            aria-hidden="true"
            className={`
              pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 
              transition duration-200 ease-in-out
              ${effectiveValue ? 'translate-x-5' : 'translate-x-0'}
            `}
          />
        </button>
      </div>
    </div>
  );
}; 